export default {
    cn: {
        chargeDividends: {
            accHead: [
                { key: 'symbol', value: '产品' },
                { key: 'buy', value: '买利息' },
                { key: 'sell', value: '卖利息' },
                { key: 'group', value: '组别' },
                { key: 'zipcode', value: 'ZIP' },
                { key: 'comment', value: 'MT备注' },
                { key: 'excute_time', value: '系统执行时间' },
                { key: 'statusDesc', value: '执行状态' },
                { key: 'modify_by', value: '最后修改人' },
            ],
            addSymbolTxt: '产品',
            addBuyTxt: '买利息(格式为"数字 货币"或"数字 pt")',
            addSellTxt: '卖利息(格式为"数字 货币"或"数字 pt")',
            addGroupTxt: '组别(格式为MT5格式)',
            addZipTxt: 'ZIP',
            addCommentTxt: 'MT备注(产品关键字为SYMBOL,手数关键字为VOLUME)',
            addExcuteTimeTxt: '执行时间(格式为YYYY-MM-DD HH:mm:ss)',

            symbolRulesRequired: '请选择产品',
            buyRulesRequired: '请输买利息',
            sellRulesRequired: '请输入卖利息',
            buyOrSellRulesInvalid: '请输入正确的格式',
            timeRulesInvalid: '请输入正确的时间格式',
            groupRulesRequired: '请输入组别',
            zipcodeRulesRequired: '请输入ZIP',
            commentRulesRequired: '请输入MT备注',
            excuteTimeRulesRequired: '请输入执行时间',

            addBtnTxt: '新增配置项',
            addDialogTitle: '请填写配置信息',
            formSelectDefaultTxt: '请选择',
            formCancelTxt: '取 消',
            formConfirmTxt: '确 定',
            deleteMsgTxt: '确定要删除这个配置吗？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失败',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失败 - 无法更新已经处理或正在处理的配置',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失败',
            lastTableColumnTxt: '操作',
            statusMapping: { 0: '未派息', 1: '派息中', 2: '修复中', 3: '部分派息', 4: '已派息' },
        }
    },
    hk: {
        chargeDividends: {
            accHead: [
                { key: 'symbol', value: '產品' },
                { key: 'buy', value: '買利息' },
                { key: 'sell', value: '賣利息' },
                { key: 'group', value: '組別' },
                { key: 'zipcode', value: 'ZIP' },
                { key: 'comment', value: 'MT備註' },
                { key: 'excute_time', value: '係統執行時間' },
                { key: 'statusDesc', value: '執行狀態' },
                { key: 'modify_by', value: '最後修改人' },
            ],
            addSymbolTxt: '產品',
            addBuyTxt: '買利息(格式為"數字 貨幣"或"數字 pt")',
            addSellTxt: '賣利息(格式為"數字 貨幣"或"數字 pt")',
            addGroupTxt: '組別(格式為MT5格式)',
            addZipTxt: 'ZIP',
            addCommentTxt: 'MT備註(產品關鍵字為SYMBOL,手數關鍵字為VOLUME)',
            addExcuteTimeTxt: '執行時間(格式為YYYY-MM-DD HH:mm:ss)',

            symbolRulesRequired: '請選擇產品',
            buyRulesRequired: '請輸入買利息',
            sellRulesRequired: '請輸入賣利息',
            buyOrSellRulesInvalid: '請輸入正確的格式',
            timeRulesInvalid: '請輸入正確的時間格式',
            groupRulesRequired: '請輸入組別',
            zipcodeRulesRequired: '請輸入ZIP',
            commentRulesRequired: '請輸入MT備註',
            excuteTimeRulesRequired: '请输入执行时间',

            addBtnTxt: '新增配置項',
            addDialogTitle: '請填寫配置信息',
            formSelectDefaultTxt: '請選擇',
            formCancelTxt: '取 消',
            formConfirmTxt: '確 定',
            deleteMsgTxt: '確定要刪除這個配置嗎？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失敗',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失敗 - 無法更新已經處理或正在處理得配置',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失敗',
            lastTableColumnTxt: '操作',
            statusMapping: { 0: '未派息', 1: '派息中', 2: '修復中', 3: '部分派息', 4: '已派息' },
        }
    },
    en: {
        chargeDividends: {
            accHead: [
                { key: 'symbol', value: 'Symbol' },
                { key: 'buy', value: 'Buy' },
                { key: 'sell', value: 'Sell' },
                { key: 'group', value: 'Group' },
                { key: 'zipcode', value: 'ZIP' },
                { key: 'comment', value: 'MT Comment' },
                { key: 'excute_time', value: 'Excute Time' },
                { key: 'statusDesc', value: 'Status' },
                { key: 'modify_by', value: 'Modify By' },
            ],
            addSymbolTxt: 'Symbol',
            addBuyTxt: 'Buy dividend(The format is "number currency" or "number pt")',
            addSellTxt: 'Sell dividend(The format is "number currency" or "number pt")',
            addGroupTxt: 'Group(The format is MT5 format)',
            addZipTxt: 'ZIP',
            addCommentTxt: 'MT Comment(The symbol keyword is SYMBOL and the lot keyword is VOLUME)',
            addExcuteTimeTxt: 'Excute Time(The format is YYYY-MM-DD HH:mm:ss)',

            symbolRulesRequired: 'Please select symbol',
            buyRulesRequired: 'Please enter buy dividend',
            sellRulesRequired: 'Please enter sell dividend',
            buyOrSellRulesInvalid: 'Please enter the correct format',
            timeRulesInvalid: 'Please enter the correct time format',
            groupRulesRequired: 'Please enter group',
            zipcodeRulesRequired: 'Please enter ZIP',
            commentRulesRequired: 'Please enter MT comment',
            excuteTimeRulesRequired: 'Please enter excute time',

            addBtnTxt: 'Add a new configuration',
            addDialogTitle: 'Please fill in the configuration information',
            formSelectDefaultTxt: 'Please select',
            formCancelTxt: 'Cancel',
            formConfirmTxt: 'OK',
            deleteMsgTxt: 'Are you sure you want to delete this configuration?',
            notifyTxt: 'Notify',
            addSuccess: 'Add configuration successfully',
            addFailed: 'Failed to add configuration',
            updateSuccess: 'Update configuration successfully',
            updateFailed: 'Failed to update configuration  - unable to update configuration that has been processed or is being processed',
            delSuccess: 'Delete configuration successfully',
            delFailed: 'Failed to delete configuration',
            lastTableColumnTxt: 'Handle',
            statusMapping: { 0: 'Awaiting dividend', 1: 'Pending dividend', 2: 'Repair dividend', 3: 'Partial dividend', 4: 'Finish dividend' },
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/report/chargeDividends.js